import styled from 'styled-components';

export const StyledTagsWrapper = styled.div`
  overflow: hidden;
  aspect-ratio: 1 / 1;
  width: 400px;
  max-width: 100%;
  margin: 0 auto;



  @media screen and (min-width: 1440px) {
    flex: 0 0 550px;
    width: 550px;
  }
`;
